export type ProblemScoreStatus = "correct" | "partial" | "incorrect";

export function isProblemScoreStatus(value: unknown): value is ProblemScoreStatus {
  return value === "correct" || value === "partial" || value === "incorrect";
}

export function scoreStatusFromResult(
  isCorrect: boolean,
  scoreRatio?: number,
): ProblemScoreStatus {
  if (isCorrect) return "correct";

  const normalizedScore =
    typeof scoreRatio === "number" ? Math.min(Math.max(scoreRatio, 0), 1) : 0;
  return normalizedScore > 0 ? "partial" : "incorrect";
}
